export default __webpack_public_path__ + "static/media/step_C@2x.03d2c0b6.png";